import { axios } from '@/utils/request'
const api = {
  Pre: '/admin.php/withdrawal/pre',
  List: '/admin.php/withdrawal/list',
  Examine: '/admin.php/withdrawal/examine'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function examine (parameter) {
  return axios({
    url: api.Examine,
    method: 'post',
    data: parameter
  })
}
